(() => {
  if (window.apparelControlsBound) return;
  window.apparelControlsBound = true;

  function useTextOption(option) {
    const input = option?.querySelector('input[type="radio"]');
    const label = option?.querySelector('label');
    if (!input || !label || option.classList.contains('aa-text-option')) return;
    option.classList.remove('color-swatch', 'aa-visual-option');
    option.classList.add('aa-text-option');
    input.removeAttribute('data-swatch');
    option.querySelector('.color-swatch__image')?.remove();
    option.querySelector('.color-swatch__label')?.remove();
    label.classList.remove('color-swatch_hidden-label');
    label.textContent = input.value;
  }

  function inspect(root) {
    if (!(root instanceof Element || root instanceof Document)) return;
    const options = [...root.querySelectorAll('.aa-visual-option')];
    if (root.matches?.('.aa-visual-option')) options.push(root);
    for (const option of options) {
      const color = option.querySelector('[data-aa-swatch-color]');
      if (color && !CSS.supports('background', color.dataset.aaSwatchColor)) useTextOption(option);
      const img = option.querySelector('img');
      if (img?.complete && !img.naturalWidth) useTextOption(option);
    }
  }
  document.addEventListener('error', event => {
    if (event.target instanceof HTMLImageElement) useTextOption(event.target.closest('.aa-visual-option'));
  }, true);
  document.addEventListener('shopify:section:load', event => inspect(event.target));
  const start = () => {
    inspect(document);
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) inspect(node);
    }).observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
